module.exports = __webpack_public_path__ + "img/default.8e8ef184.png";